import type { FaireThemeEntity } from "../../entity_types/theme";

export const sparkling_gift_sets: FaireThemeEntity = {
  token: "sparkling-gift-sets",
  type: "theme",
  name: "Sparkling Gift Sets",
  description: "Curated earring sets and pendant necklaces as perfect impulse gifts -- wholesale prices starting under $10.",
  teaser: "Under-$10 wholesale gift bundles for your front counter display.",
  detail: "Your brick-and-mortar beauty + clothing focus is perfect for high-margin, small-scale gift items customers grab during visits. Novae CZ Mix Earring Set and necklaces with wholesale prices between $7.82-$14.72.",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ar6ja253qt",
    "p_pqf2f49nzz",
    "p_dvc55z5255",
    "p_ut3tbs6mrw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
